import { useContext, useRef } from 'react';
import { useFlags } from '../../services/flags';
import { UnknownRecord } from '../../types/UnknownRecord';
import { useEventBus } from '../../util/EventBus';
import { AnalyticsContext } from '../AnalyticsContext';

/* eslint-disable no-console */

/** Observes analytics events and logs them to the console when the "logEvents" flag is set.
 *
 * @requires <AnalyticsProvider> as an ancestor in the tree. */
export const AnalyticsLogger = () => {
  const { bus } = useContext(AnalyticsContext);
  const shouldLogEventsRef = useRef(false);
  const { logEvents } = useFlags();

  if (logEvents) {
    shouldLogEventsRef.current = true;
  }

  useEventBus(bus, ({ name, data }) => {
    if (
      shouldLogEventsRef.current &&
      typeof console.groupCollapsed === 'function' &&
      typeof console.table === 'function' &&
      typeof console.groupEnd === 'function'
    ) {
      console.groupCollapsed(name);
      console.table(serialize(data));
      console.groupEnd();
    }
  });

  return null;
};

const serialize = (object: object, collector: UnknownRecord = {}, prefix = '') => {
  Object.entries(object).forEach(([key, value]) => {
    const pathKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'object' && value !== null) {
      serialize(value, collector, pathKey);
    } else {
      collector[pathKey] = value;
    }
  });

  return collector;
};
